<template>
  <el-skeleton :style="{ '--el-skeleton-circle-size': '200px' }" v-if="page.loading">
    <template #template>
      <el-skeleton-item variant="text" />
    </template>
  </el-skeleton>
  <div v-else>{{ page.name }}</div>
</template>
<script setup>
import { defineProps, reactive, watch, getCurrentInstance } from 'vue'
const props = defineProps({
  modelValue: { type: String }
})
const { proxy } = getCurrentInstance()
const page = reactive({
  loading: false,
  name: '未知'
})
const getData = async () => {
  page.loading = true
  let res = await proxy.$http.post('/app/custClient/region/getCascade', JSON.parse(props.modelValue))
  if (res.code === 0) {
    page.name = res.data.join('')
  }
  page.loading = false
}
watch(
  () => props.modelValue,
  (newVal) => {
    page.name = '未知'
    if (newVal) {
      getData()
    }
  },
  { immediate: true }
)
</script>
